'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGoogleMaps = require('react-google-maps');

var _doctifyUtils = require('doctify-utils');

require('../../src/styles/external.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MARKER_WIDTH = 29;
var MARKER_HEIGHT = 42;

var MapElement = (0, _reactGoogleMaps.withGoogleMap)(function (props) {
	return _react2.default.createElement(
		_reactGoogleMaps.GoogleMap,
		{
			ref: props.onMapLoad,
			defaultZoom: props.defaultZoom,
			defaultCenter: props.defaultCenter || props.markers[0].position,
			center: props.center,
			onClick: props.onMapClick,
			onRightClick: props.onMapRightClick,
			onDragStart: props.onMapDragStart },
		props.markers.map(function (marker, index) {
			return _react2.default.createElement(_reactGoogleMaps.Marker, {
				key: 'map-marker-' + index,
				position: marker.position,
				icon: {
					url: props.iconUrl,
					scaledSize: new window.google.maps.Size(MARKER_WIDTH, MARKER_HEIGHT)
				},
				onClick: props.onMarkerClick(marker),
				onRightClick: props.onMarkerRightClick(marker) });
		})
	);
});

var mapInstance = void 0;

var generateBounds = function generateBounds(props) {
	var SMALL_LAT_LNG = .001;

	var bounds = window && window.google && window.google.maps && new window.google.maps.LatLngBounds() || null;
	if (props.markers && props.markers.length === 1) {
		var singlePracticePosition = props.markers[0].position;
		bounds.extend(new window.google.maps.LatLng({ lat: singlePracticePosition.lat + SMALL_LAT_LNG, lng: singlePracticePosition.lng + SMALL_LAT_LNG })).extend(new window.google.maps.LatLng({ lat: singlePracticePosition.lat - SMALL_LAT_LNG, lng: singlePracticePosition.lng - SMALL_LAT_LNG }));
	} else {
		props.markers.forEach(function (marker) {
			return bounds.extend(marker.position);
		});
	}
	return bounds;
};

var DoctifyGoogleMap = function (_React$Component) {
	(0, _inherits3.default)(DoctifyGoogleMap, _React$Component);

	function DoctifyGoogleMap(props) {
		(0, _classCallCheck3.default)(this, DoctifyGoogleMap);

		var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));

		_this.state = {
			mapLoaded: false,
			mapInstance: null,
			bounds: typeof window !== 'undefined' && window && window.google && window.google.maps ? generateBounds(_this.props) : null,
			shouldUpdateMap: true
		};
		return _this;
	}

	DoctifyGoogleMap.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (nextProps.center !== this.props.center || !nextProps.center && nextProps.showAllMarkers !== this.props.showAllMarkers) {
			this.setState({ shouldUpdateMap: true });
		}
	};

	DoctifyGoogleMap.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		if (!window.google) {
			var GoogleMapsLoader = require('google-maps');
			GoogleMapsLoader.LIBRARIES = ['places'];
			GoogleMapsLoader.KEY = _doctifyUtils.GOOGLE_MAP_KEY;
			GoogleMapsLoader.onLoad(function () {
				_this2.setState((0, _extends3.default)({}, _this2.state, { bounds: generateBounds(_this2.props), shouldUpdateMap: true }));
			});
			GoogleMapsLoader.load();
		}
	};

	DoctifyGoogleMap.prototype.componentWillUnmount = function componentWillUnmount() {
		mapInstance = null;
	};

	DoctifyGoogleMap.prototype.render = function render() {
		var _this3 = this;

		if (typeof window !== 'undefined' && window.google) {
			return _react2.default.createElement(MapElement, {
				containerElement: _react2.default.createElement('div', { style: this.props.containerElementStyle }),
				mapElement: _react2.default.createElement('div', { style: this.props.mapElementStyle }),
				onMapLoad: function onMapLoad(ref) {
					mapInstance = !mapInstance ? ref : mapInstance;
					_this3.props.onMapLoad(ref);
					if (_this3.state.shouldUpdateMap) {
						if (_this3.props.showAllMarkers && window && window.google && window.google.maps && mapInstance) {
							mapInstance.fitBounds(_this3.state.bounds);
						} else if (mapInstance) {
							mapInstance.fitBounds(new window.google.maps.LatLngBounds(new window.google.maps.LatLng({ lat: _this3.props.center.lat, lng: _this3.props.center.lng })).extend(new window.google.maps.LatLng({ lat: _this3.props.center.lat + .001, lng: _this3.props.center.lng + .001 })).extend(new window.google.maps.LatLng({ lat: _this3.props.center.lat - .001, lng: _this3.props.center.lng - .001 })));
						}
						_this3.setState({ shouldUpdateMap: false });
					}
				},
				onClick: this.props.onMapClick,
				onRightClick: this.props.onMapRightClick,
				onDragStart: this.props.onMapDragStart,
				markers: this.props.markers,
				iconUrl: this.props.iconUrl,
				defaultZoom: this.props.defaultZoom,
				defaultCenter: this.props.defaultCenter,
				center: this.props.center,
				onMarkerClick: this.props.onMarkerClick,
				onMarkerRightClick: this.props.onMarkerRightClick
			});
		} else {
			return null;
		}
	};

	return DoctifyGoogleMap;
}(_react2.default.Component);

DoctifyGoogleMap.propTypes = {
	markers: require('react').PropTypes.arrayOf(require('react').PropTypes.any),
	iconUrl: require('react').PropTypes.string,
	defaultZoom: require('react').PropTypes.number,
	defaultCenter: require('react').PropTypes.shape({
		lat: require('react').PropTypes.number.isRequired,
		lng: require('react').PropTypes.number.isRequired
	}),
	center: require('react').PropTypes.shape({
		lat: require('react').PropTypes.number.isRequired,
		lng: require('react').PropTypes.number.isRequired
	}),
	showAllMarkers: require('react').PropTypes.any,
	onMapLoad: require('react').PropTypes.func,
	onMapClick: require('react').PropTypes.func,
	onMapRightClick: require('react').PropTypes.func,
	onMapDragStart: require('react').PropTypes.func,
	onMarkerClick: require('react').PropTypes.func,
	onMarkerRightClick: require('react').PropTypes.func,
	containerElementStyle: require('react').PropTypes.shape({
		height: require('react').PropTypes.string.isRequired,
		width: require('react').PropTypes.string.isRequired
	}),
	mapElementStyle: require('react').PropTypes.shape({
		height: require('react').PropTypes.string.isRequired,
		width: require('react').PropTypes.string.isRequired
	})
};
exports.default = DoctifyGoogleMap;


DoctifyGoogleMap.displayName = 'DoctifyGoogleMap';

DoctifyGoogleMap.defaultProps = {
	markers: [],
	defaultZoom: 15,
	onMapLoad: function onMapLoad() {},
	onMapClick: function onMapClick() {},
	onMapRightClick: function onMapRightClick() {},
	onMapDragStart: function onMapDragStart() {},
	onMarkerClick: function onMarkerClick() {},
	onMarkerRightClick: function onMarkerRightClick() {},

	containerElementStyle: { height: '100%', width: '100%' },
	mapElementStyle: { height: '100%', width: '100%' }
};


// WEBPACK FOOTER //
// ./components/doctify-google-map/lib/components/doctify-google-map.js